<script lang="ts" setup>
import { IconLock } from "@tabler/icons-vue";
import { IconHome } from "@tabler/icons-vue";
import { defineProps } from "vue";
import { useLocaleStore } from "../../stores/locale";
import { useI18n } from "vue-i18n";
import { useUserStore } from "../../stores/user";

const t = useI18n().t;
const localeStore = useLocaleStore();
const userStore = useUserStore();
defineProps({
  title: {
    type: String,
    default: "Dashboard",
  },
});
const logout = async () => {
  await userStore.logout();
  document.cookie.split(";").forEach((c) => {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
  });
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  localStorage.removeItem("calculatorCart");
  sessionStorage.clear();
  window.location.href = "/login";
};
// const pageTitle = computed(() => {
//     //get title from router meta title property
//     const route = useRoute();
//     const title = route.meta.title;
//     if (title) {
//         return t(title?.toString());
//     }
// });

const showHideSidebar = () => {
  const sidebar = document.querySelector(".sidebar-admin") as HTMLElement;
  if (sidebar) {
    // sidebar.classList.toggle("hidden");
    sidebar.style.display = sidebar.style.display === "none" || sidebar.style.display == '' || sidebar.style.display == null ? "block" : "none";
  }
};
</script>
<template>
  <div class="layout-container" :dir="localeStore.locale === 'ar' ? 'rtl' : 'ltr'">
    <!-- Navbar -->
    <nav class="bg-gray-800 text-white p-2 h-[5%]">
      <div class="flex justify-between items-center align-content-center p-1">
        <div class="flex w-25 justify-content-start px-1">
          <h4 class="font-bold text-white">{{ t("Admin") }}</h4>
          <!-- <h4 class="font-bold text-white">{{ pageTitle }}</h4> -->
        </div>
        <div class="flex items-center gap-2">
          <span>{{ t("Welcome") }}, {{ userStore.user.name }}</span>
          <a
            href="/"
            class="bg-gray-400 hover:bg-orange-100 rounded flex items-center px-1"
          >
            <IconHome stroke="{2}" />
          </a>
          <a
            href="#!"
            class="bg-red-500 hover:bg-red-600 rounded flex px-1"
            @click="logout"
          >
            <IconLock stroke="{2}" />
          </a>
        </div>
      </div>
    </nav>
    <i
      class="fa fa-bars border border-2 rounded-3 p-2 w-8 bars-btn"
      @click="showHideSidebar"
    ></i>
    <div class="flex gap-1 overflow-hidden">
      <!-- Sidebar -->
      <aside class="sidebar-admin text-center">
        <ul class="space-y-2" v-if="userStore.user.ly < 3">
          <li>
            <a
              href="/admin"
              class="block p-2 mt-2 hover:bg-gray-300 rounded"
              :class="{ 'router-link-active': $route.path === '/admin' }"
            >
              {{ t("Dashboard") }}
            </a>
          </li>
          <li>
            <router-link
              :to="'/admin/projects'"
              class="block p-2 hover:bg-gray-300 rounded"
              :class="{
                'router-link-active': $route.path === '/admin/projects',
              }"
            >
              {{ t("Projects") }}
            </router-link>
          </li>
          <li>
            <router-link
              :to="'/admin/users'"
              class="block p-2 hover:bg-gray-300 rounded"
              :class="{ 'router-link-active': $route.path === '/admin/users' }"
            >
              {{ t("Users") }}
            </router-link>
          </li>
          <li>
            <router-link
              :to="'/admin/estimations'"
              class="block p-2 hover:bg-gray-300 rounded"
              :class="{
                'router-link-active': $route.path === '/admin/estimations',
              }"
            >
              {{ t("Estimations") }}
            </router-link>
          </li>
          <li>
            <router-link
              :to="'/admin/partners'"
              class="block p-2 hover:bg-gray-300 rounded"
              :class="{
                'router-link-active': $route.path === '/admin/partners',
              }"
            >
              {{ t("Partners") }}
            </router-link>
          </li>
          <li>
            <router-link
              :to="'/admin/config'"
              class="block p-2 hover:bg-gray-300 rounded"
              :class="{ 'router-link-active': $route.path === '/admin/config' }"
            >
              {{ t("Configurations") }}
            </router-link>
          </li>
        </ul>
        <ul v-if="userStore.user.ly >= 3">
          <li>
            <router-link
              :to="'/admin/my-orders'"
              class="block p-2 hover:bg-gray-300 rounded"
              :class="{
                'router-link-active': $route.path === '/admin/my-orders',
              }"
            >
              {{ t("My Orders") }}
            </router-link>
          </li>
        </ul>
      </aside>

      <!-- Main Content -->
      <main>
        <slot></slot>
      </main>
    </div>

    <!-- Footer -->
    <footer class="bg-gray-800 text-white">
      <div class="container mx-auto text-center">
        <p>&copy; 2025 Admin Dashboard. All rights reserved.</p>
      </div>
    </footer>
  </div>
</template>

<style lang="scss" scoped>
main {
  flex-grow: 1;
  padding: 1rem;
  background-color: #f7fafc;
  min-height: calc(100vh - 6rem) !important; /* Adjust based on navbar and footer height */
    height: auto;
    overflow-y: auto;
}
.sidebar-admin {
  background-color: #f7fafc;
  /*padding: 1rem;*/
  padding-top: 2rem;
  height: 100vh;
  min-width: 200px !important;
  overflow-y: auto;
  position: relative;
}
.bars-btn {
    display: none;
}
@media screen and (min-width: 769px) {
    .sidebar-admin {
      display: block !important;
  }
    
}
@media screen and (max-width: 768px) {
  .sidebar-admin {
    position: fixed;
    top: 50px;
    right: 0px;
    width: 10%;
    height: 100%;
    z-index: 1000;
    display: none;
  }
  .bars-btn {
    display: block;
    position: fixed;
    top: 3rem;
    right: 0.1rem;
    z-index: 99999;
    background-color: #edf2f7;
    border-radius: 0.375rem;
    cursor: pointer;
  }
  .sidebar-admin ul {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  nav {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
  }

  main {
    padding: 6rem 2rem;
  }
}

.sidebar-admin ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.sidebar-admin li {
  margin-bottom: 1rem;
}

.sidebar-admin a {
  text-decoration: none;
  color: #333;
  font-weight: bold;
}

.sidebar-admin a:hover {
  background-color: #e2e8f0;
  color: #2d3748;
}

footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2rem;
  text-align: center;
  padding: 0.1rem;
  background-color: #2d3748;
  color: white;
}

footer p {
  margin: 0;
  font-size: 0.875rem;
  color: #a0aec0;
}

.layout-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
}

// main {
//   padding-inline: 1rem;
//   padding-top: 1rem;
//   padding-bottom: 3rem;
//   // flex-grow: 1;
//   overflow-y: auto;
//   background-color: #edf2f7;
//   min-height: auto;
//   height: auto;
//   flex-grow: 1;
// }
.router-link-active {
  background-color: #e2e8f0;
  color: #2d3748;
  font-weight: bold;
  border-radius: 0.375rem;
}
</style>
